import { IConfig } from './interfaces';

/**
 * Product types that should not display or require quantity fields
 */
export const PRODUCT_TYPES_WITHOUT_QUANTITY = ['property-rentals'];

/**
 * Helper function to check if config order contains product types without quantity
 * @param config - The config object containing order items
 * @returns true if any product in the order is a type that doesn't require quantity
 */
export const hasProductTypeWithoutQuantity = (config: IConfig): boolean => {
	return config.order.some((order) => PRODUCT_TYPES_WITHOUT_QUANTITY.includes(order.productType));
};

/**
 * Helper function to get the product type from the config
 * Assumes all products in the order have the same type
 * @param config - The config object containing order items
 * @returns The product type of the first order item, or empty string if no orders
 */
export const getProductType = (config: IConfig): string => {
	return config.order.length > 0 ? config.order[0].productType : '';
};

/**
 * Check if the current config is for property rentals
 */
export const isPropertyRental = (config: IConfig): boolean => {
	return getProductType(config) === 'property-rentals';
};

/**
 * Get primary buyer label based on product type
 */
export const getPrimaryBuyerLabel = (config: IConfig): string => {
	return isPropertyRental(config) ? 'Primary Booker' : 'Primary Buyer';
};

/**
 * Get co-buyer label based on product type
 */
export const getCobuyerLabel = (config: IConfig, index?: number): string => {
	if (isPropertyRental(config)) {
		return index !== undefined ? `Guest ${index}` : 'Guest';
	}
	return index !== undefined ? `Co-Buyer ${index}` : 'Co-Buyer';
};

/**
 * Get plural co-buyer label based on product type
 */
export const getCobuyersLabel = (config: IConfig): string => {
	return isPropertyRental(config) ? 'Guests' : 'Cobuyers';
};
